import { useContext, useState } from "react";
import styles from "./Bxgy.module.css";
import { Button, Divider } from "@shopify/polaris";
import { BxgyBundleContext } from "./Bxgy";
import { BundleTypes } from "../constants";
import DesignTabsWrapper from "../../../components/DesignTabsWrapper/DesignTabsWrapper";
import { CombinedBundleConfigInterface } from "../Types";
import DesignGeneralCard from "../CommonFields/DesignGeneralCard";
import DesignProductCard from "../CommonFields/DesignProductCard";
import DesignFreeGift from "../CommonFields/DesignFreeGift";
import DesignFooterCard from "../CommonFields/DesignFooterCard";

const BxgyDesignForm = () => {
    const context = useContext(BxgyBundleContext);
    const [activeDesignTab, setActiveDesignTab] = useState(0);

    if (!context) return;
    const {
        fields: {
            bundles_design: {
                default_cta,
                bundle_title_color,
                bundle_title_style,
                bundle_title_size,
                bundle_widget_bg,
                bundle_widget_font_family,
                product_background_color,
                product_border_color,
                product_name_color,
                product_name_style,
                product_name_size,
                product_price_color,
                product_price_style,
                product_price_size,
                product_img_size,
                product_img_show,
                product_img_border_radius,

                highlighted_price_tag_size,
                highlighted_price_tag_color,
                highlighted_price_tag_style,
                total_footer_text_size,
                total_footer_text_color,
                total_footer_text_style,
                total_footer_price_text_size,
                total_footer_price_text_style,
                total_footer_background_color,
                add_to_cart_bg_color,
                add_to_cart_border_radius,
                add_to_cart_border_color,
                add_to_cart_border_width,
                add_to_cart_text_color,
                add_to_cart_text_size,
                add_to_cart_text_style,
                variant_selector_text_size,
                variant_selector_text_style,
                variant_selector_text_color,
                special_text_background_color,
                special_text_color,
                special_text_font_size,
                special_text_style,
                product_img_border_width,
                product_img_border_color,
                free_gift_header_bg_color,
                free_gift_header_color,
                free_gift_header_size,
                free_gift_header_style,
                free_gift_bg_color,
                free_gift_text_color,
                free_gift_text_style,
                free_gift_text_size,
                footer_save_money_text_size,
                footer_save_money_text_style,
                footer_save_money_text_color,
                swatches_select_color,
                // free_gift_border_width,
                // free_gift_border_color,
                border_width,
                border_radius,
            },
            allow_free_gifts,
            show_swatches,
        },
        handleNext,
        submit,
        bundleConfig,
        validate,
        dispatchBundleConfig,
        inspectorTarget,
    } = context;

    const showFreeGiftSettings = !!allow_free_gifts?.value;
    const showSwatchesColor = !!show_swatches?.value;
    const showFooterKeys = !default_cta?.value;

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: 10 }}>
                <Divider borderColor="border" />
            </div>

            <DesignTabsWrapper
                bundleConfig={bundleConfig as CombinedBundleConfigInterface}
                activeDesignTab={activeDesignTab}
                setActiveDesignTab={setActiveDesignTab}
                showFreeGiftSettings={showFreeGiftSettings}
                validate={validate}
                submit={submit}
                inspectorTarget={inspectorTarget}
            >
                {activeDesignTab == 0 && (
                    <DesignGeneralCard
                        bundleType={BundleTypes.BXGY}
                        dispatchBundleConfig={dispatchBundleConfig}
                        bundle_widget_bg={bundle_widget_bg}
                        bundle_title_color={bundle_title_color}
                        bundle_widget_font_family={bundle_widget_font_family}
                        bundle_title_style={bundle_title_style}
                        bundle_title_size={bundle_title_size}
                        special_text_background_color={special_text_background_color}
                        special_text_color={special_text_color}
                        special_text_font_size={special_text_font_size}
                        special_text_style={special_text_style}
                    />
                )}

                {activeDesignTab == 1 && (
                    <DesignProductCard
                        dispatchBundleConfig={dispatchBundleConfig}
                        bundleType={BundleTypes.BXGY}
                        product_background_color={product_background_color}
                        product_border_color={product_border_color}
                        product_name_color={product_name_color}
                        product_price_color={product_price_color}
                        product_img_border_color={product_img_border_color}
                        product_name_style={product_name_style}
                        product_name_size={product_name_size}
                        product_price_style={product_price_style}
                        product_price_size={product_price_size}
                        product_img_size={product_img_size}
                        product_img_show={product_img_show}
                        highlighted_price_tag_color={highlighted_price_tag_color}
                        highlighted_price_tag_style={highlighted_price_tag_style}
                        highlighted_price_tag_size={highlighted_price_tag_size}
                        product_img_border_width={product_img_border_width}
                        variant_selector_text_size={variant_selector_text_size}
                        variant_selector_text_style={variant_selector_text_style}
                        variant_selector_text_color={variant_selector_text_color}
                        // swatches_select_color={showSwatchesColor ? swatches_select_color : null}
                        product_img_border_radius={product_img_border_radius}
                        border_radius={border_radius}
                        border_width={border_width}
                    />
                )}
                {activeDesignTab == 2 &&
                    (showFreeGiftSettings ? (
                        <DesignFreeGift
                            dispatchBundleConfig={dispatchBundleConfig}
                            bundleType={BundleTypes.BXGY}
                            free_gift_header_bg_color={free_gift_header_bg_color}
                            free_gift_header_color={free_gift_header_color}
                            free_gift_header_size={free_gift_header_size}
                            free_gift_header_style={free_gift_header_style}
                            free_gift_bg_color={free_gift_bg_color}
                            free_gift_text_color={free_gift_text_color}
                            free_gift_text_size={free_gift_text_size}
                            free_gift_text_style={free_gift_text_style}
                        />
                    ) : (
                        <DesignFooterCard
                            dispatchBundleConfig={dispatchBundleConfig}
                            bundleType={BundleTypes.BXGY}
                            total_footer_text_color={total_footer_text_color}
                            total_footer_background_color={total_footer_background_color}
                            add_to_cart_bg_color={add_to_cart_bg_color}
                            add_to_cart_border_color={add_to_cart_border_color}
                            add_to_cart_border_width={add_to_cart_border_width}
                            add_to_cart_border_radius={add_to_cart_border_radius}
                            add_to_cart_text_color={add_to_cart_text_color}
                            total_footer_text_size={total_footer_text_size}
                            total_footer_text_style={total_footer_text_style}
                            total_footer_price_text_size={total_footer_price_text_size}
                            total_footer_price_text_style={total_footer_price_text_style}
                            add_to_cart_text_size={add_to_cart_text_size}
                            add_to_cart_text_style={add_to_cart_text_style}
                            footer_save_money_text_size={footer_save_money_text_size}
                            footer_save_money_text_style={footer_save_money_text_style}
                            footer_save_money_text_color={footer_save_money_text_color}
                            showFooterKeys={showFooterKeys}
                        />
                    ))}

                {activeDesignTab == 3 && (
                    <DesignFooterCard
                        dispatchBundleConfig={dispatchBundleConfig}
                        bundleType={BundleTypes.BXGY}
                        total_footer_text_color={total_footer_text_color}
                        total_footer_background_color={total_footer_background_color}
                        add_to_cart_bg_color={add_to_cart_bg_color}
                        add_to_cart_border_color={add_to_cart_border_color}
                        add_to_cart_border_width={add_to_cart_border_width}
                        add_to_cart_border_radius={add_to_cart_border_radius}
                        add_to_cart_text_color={add_to_cart_text_color}
                        total_footer_text_size={total_footer_text_size}
                        total_footer_text_style={total_footer_text_style}
                        total_footer_price_text_size={total_footer_price_text_size}
                        total_footer_price_text_style={total_footer_price_text_style}
                        add_to_cart_text_size={add_to_cart_text_size}
                        add_to_cart_text_style={add_to_cart_text_style}
                        footer_save_money_text_size={footer_save_money_text_size}
                        footer_save_money_text_style={footer_save_money_text_style}
                        footer_save_money_text_color={footer_save_money_text_color}
                        showFooterKeys={showFooterKeys}
                    />
                )}
            </DesignTabsWrapper>

            {handleNext && (
                <>
                    <div className={styles.dividerStyle}>
                        <Divider borderColor="border" />
                    </div>
                    <div className={styles.bottomRowCta}>
                        <Button onClick={() => handleNext(0, "Content")}>Back</Button>
                        <Button onClick={() => handleNext(2, "Target")}>Next</Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default BxgyDesignForm;
